<template>
  <div>
    <van-card
      v-for="order in orders"
      :key="order.id"
      :title="order.productName"
      :desc="'订单编号：' + order.orderNo"
      :thumb="order.productImg"
      class="order-card"

      @click="handleOrderClick(order.id)"
    >
      <template #tags>
        <div class="order-time">订单时间：{{ formatTime(order.tradeTime) }}</div>
        <div class="order-time">兑换码：{{ order.code }}</div>
      </template>
    </van-card>
  </div>
</template>

<script>
export default {
  name: 'OrderList',
  props: {
    orders: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleOrderClick(orderId) {
      this.$router.push({
        name: 'exchange-success',
        params: { id: orderId }
      })
    },
    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, '0');
      const d = date.getDate().toString().padStart(2, '0');
      const h = date.getHours().toString().padStart(2, '0');
      const min = date.getMinutes().toString().padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}`;
    }
  }
};
</script>

<style scoped>
.order-card {
  margin-bottom: 12px;
  cursor: pointer;
}


.order-time {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}
</style>